import { BoxProps, Flex, Header, Text, ShorthandValue, Skeleton } from "@fluentui/react-northstar";
import React from "react";
import styles from "./title.module.scss";

export interface TitleProps {
    text: string;
    isHeader?: boolean;
    icon?: ShorthandValue<BoxProps>;
    isLoading?: boolean;
    vAlign?: "start" | "center" | "end" | "stretch";
    className?: string;
    size?: "small" | "medium" | "large";
    weight?: "semibold";
}

export const Title: React.FC<TitleProps> = (props) => {
    const getSize = () => {
        if (props.isHeader) {
            return <Header className={styles.header} as="h4" content={props.text} />;
        }
        return (
            <Text className={styles.header} weight={props.weight} size={props.size ?? "large"} content={props.text} />
        );
    };

    return (
        <Flex className={props.className} vAlign={props.vAlign}>
            {props.icon && <div className={styles.icon}>{props.icon}</div>}
            {props.isLoading ? (
                <Skeleton animation="wave">
                    <Skeleton.Line width="240px"></Skeleton.Line>
                    <Skeleton.Line width="150px"></Skeleton.Line>
                </Skeleton>
            ) : (
                getSize()
            )}
        </Flex>
    );
};
